import * as React from "react";
import { Provider } from "react-redux";
import createStore from "core/createStore";

const store = createStore();

export const ApplicationContainer: React.SFC = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);
